import { render, staticRenderFns } from "./bottomTabBar.vue?vue&type=template&id=79bcf44a"
import script from "./bottomTabBar.vue?vue&type=script&lang=js"
export * from "./bottomTabBar.vue?vue&type=script&lang=js"
import style0 from "./bottomTabBar.vue?vue&type=style&index=0&id=79bcf44a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports